import type { CurrentPlan, SubscriptionView } from "@/lib/api/organizations";
import { formatMoneyCents } from "@/lib/format";

/// One seat for one billing period, in the currency it is billed in.
export interface SeatRate {
  amount: number;
  currency: string;
  taxOnTop: boolean;
}

/// The subscription's own price wins. The plan's is used only where the
/// subscription bills in the plan's currency, so a local price never shows as
/// the USD list price.
export function seatRate(
  plan: CurrentPlan | null,
  subscription: SubscriptionView | null | undefined,
): SeatRate | null {
  if (!plan || plan.price_cents <= 0) return null;
  const taxOnTop = subscription?.tax_on_top === true;
  const billedIn = subscription?.currency_code ?? null;
  if (billedIn && subscription?.unit_price_minor != null) {
    return {
      amount: subscription.unit_price_minor,
      currency: billedIn,
      taxOnTop,
    };
  }
  if (billedIn && billedIn !== plan.currency) return null;
  return { amount: plan.price_cents, currency: plan.currency, taxOnTop };
}

export function formatSeatMoney(rate: SeatRate, seats = 1): string {
  return formatMoneyCents(rate.amount * seats, rate.currency);
}

/// The website's wording, so a buyer reads the same thing before and after.
export const PLUS_TAX = "plus tax";
